import React from 'react'
import '../styles/Button1.css'
import { Link } from 'react-router-dom';
export default function Button({ title, style, linka }) {

    return (
        <div>
            <Link style={{ textDecoration: 'none' }} to={linka}> <button className="buttonasdj bbbbtttt" style={style}>{title}</button></Link>
        </div>
    )
}
